<template>
    <div id="quote">
        <v-alert dense border="bottom" type="primary" icon="mdi-information">
            Quote
            <div style="float: right">
                <v-btn
                    color="grey lighten-5"
                    rounded
                    small
                    class="mb-1 text--primary"
                    @click="add_close()"
                    v-if="team_name == 'ODM' || emp_id == 'P22-083'"
                >
                    <v-icon color="primary">mdi-plus</v-icon>
                    <span>Create Quote</span>
                </v-btn>
            </div>
        </v-alert>

        <v-row v-if="data_main.length == 0">
            <v-col cols="12" class="text-center">
                <span class="font-b"> No results found. </span>
            </v-col>
        </v-row>

        <v-row v-else dense>
            <v-col cols="12">
                <v-simple-table class="table-inv">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center">#</th>
                                <th class="text-center">Quote Date</th>
                                <th class="text-center">Quote Status</th>
                                <th class="text-center">Grand Total</th>
                                <th class="text-center">Receipt No</th>
                                <th class="text-center">Action</th>
                                <th class="text-center">ใบเสนอราคา</th>
                                <th class="text-center">ใบเสร็จ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in data_main" :key="index">
                                <td class="text-center">{{ index + 1 }}.</td>
                                <td class="text-center">
                                    {{ row.quote_date }}
                                </td>
                                <td class="text-center">
                                    <span
                                        :class="
                                            row.quote_status == 'cancelled'
                                                ? 'font-b red--text'
                                                : 'font-b primary--text'
                                        "
                                    >
                                        {{ row.quote_status }}
                                    </span>
                                </td>
                                <td class="text-right">
                                    {{ formatPrice(row.grand_total) }}
                                </td>
                                <td class="text-center">
                                    {{ row.receipt_no }}
                                </td>
                                <td class="text-center">
                                    <v-tooltip top v-if="team_name == 'ODM'">
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-if="
                                                    row.quote_status !=
                                                        'cancelled'
                                                "
                                                v-on="on"
                                                x-small
                                                fab
                                                color="primary"
                                                @click="
                                                    open_update_quote(
                                                        row.quote_id
                                                    )
                                                "
                                            >
                                                <v-icon>
                                                    mdi-clipboard-check-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Update Status</span>
                                    </v-tooltip>

                                    <v-tooltip
                                        top
                                        v-if="
                                            team_name == 'ODM' ||
                                                emp_id == 'P11-010' ||
                                                emp_id == 'P22-083'
                                        "
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                class="ml-3"
                                                x-small
                                                fab
                                                color="amber"
                                                v-on="on"
                                                dark
                                                v-if="
                                                    row.quote_status !=
                                                        'cancelled'
                                                "
                                                @click="
                                                    open_edit_quote(
                                                        row.quote_id
                                                    )
                                                "
                                            >
                                                <v-icon> mdi-pencil </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit</span>
                                    </v-tooltip>

                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                class="ml-3"
                                                x-small
                                                fab
                                                color="green"
                                                v-on="on"
                                                dark
                                                v-if="
                                                    (row.quote_status ==
                                                        'approved' ||
                                                        row.quote_status ==
                                                            'cancelled') &&
                                                        row.receipt_no === null
                                                "
                                                @click="
                                                    gen_receipt(row.quote_id)
                                                "
                                            >
                                                <v-icon>
                                                    mdi-file-document-edit-outline
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Gen. Receipt</span>
                                    </v-tooltip>
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        x-small
                                        fab
                                        @click="
                                            get_print_quote(
                                                row.quote_id,
                                                'Quote'
                                            )
                                        "
                                    >
                                        <v-icon color="primary">
                                            mdi-printer
                                        </v-icon>
                                    </v-btn>
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        v-if="row.receipt_no"
                                        :disabled="
                                            row.status_print == 1 &&
                                                emp_id != 'P11-010' &&
                                                emp_id != 'P18-054' &&
                                                emp_id != 'P11-063' &&
                                                emp_id != 'P22-083'
                                        "
                                        x-small
                                        fab
                                        @click="
                                            get_print_quote(
                                                row.quote_id,
                                                'Receipt'
                                            )
                                        "
                                    >
                                        <v-icon color="primary">
                                            mdi-printer
                                        </v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialog_update"
            class="mx-auto"
            max-width="425"
            persistent
        >
            <v-form method="post" id="nativeFormresponse">
                <v-card>
                    <v-card-title>
                        <span class="headline">อัพเดทสถานะการเสนอราคา</span>
                    </v-card-title>
                    <v-row>
                        <v-col cols="10" offset="1">
                            <v-select
                                label="สถานะการเสนอราคา"
                                :items="status_update"
                                item-text="name"
                                item-value="id"
                                outlined
                                dense
                                v-model="form_update.quote_status"
                                @change="clear_type()"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="close_dialog_update()"
                        >
                            close
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click="update_quote()">
                            update
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

        <v-dialog
            v-model="dialog_detail"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="close_dialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-list three-line subheader>
                        <v-list-item>
                            <v-list-item-content class="mt-5">
                                <v-row>
                                    <v-col class="mar-t-15" cols="12" md="4">
                                        <v-dialog
                                            ref="dialog"
                                            v-model="modal"
                                            :return-value.sync="
                                                data_main_case.quote_date
                                            "
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="
                                                        data_main_case.quote_date
                                                    "
                                                    label="วันที่เสนอราคา"
                                                    prepend-icon=""
                                                    readonly
                                                    v-on="on"
                                                    outlined
                                                    dense
                                                    :disabled="
                                                        data_main_case.quote_status !=
                                                            'pending'
                                                    "
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="date"
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="modal = false"
                                                    >Cancel</v-btn
                                                >
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="
                                                        $refs.dialog.save(date)
                                                    "
                                                    >OK</v-btn
                                                >
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>
                                    <v-col class="mar-t-15" cols="12" md="4">
                                        <v-text-field
                                            v-model="
                                                data_main_case.customer_name
                                            "
                                            label="ชื่อลูกค้า / ชื่อบริษัท"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="mar-t-15" cols="12" md="9">
                                        <v-textarea
                                            outlined
                                            dense
                                            v-model="
                                                data_main_case.site_address
                                            "
                                            label="ที่อยู่ลูกค้า"
                                            rows="4"
                                        ></v-textarea>
                                    </v-col>
                                    <v-col class="mar-t-15" cols="12" md="4">
                                        <v-select
                                            label="ประเภทลูกค้า"
                                            :items="typex"
                                            item-text="name"
                                            item-value="id"
                                            outlined
                                            dense
                                            v-model="data_main_case.type"
                                            @change="clear_type()"
                                        ></v-select>
                                    </v-col>
                                    <v-col class="mar-t-15" cols="12" md="4">
                                        <v-text-field
                                            v-model="data_main_case.tax_id"
                                            label="เลขที่ประจำตัวผู้เสียภาษี"
                                            outlined
                                            dense
                                            :disabled="
                                                data_main_case.type ==
                                                    'foreigner'
                                            "
                                            :rules="rules1"
                                            counter="13"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="mar-t-15" cols="12" md="4">
                                        <v-text-field
                                            v-if="
                                                data_main_case.type == 'branch'
                                            "
                                            v-model="data_main_case.branch_no"
                                            label="เลขที่สาขา"
                                            outlined
                                            dense
                                            :rules="rules2"
                                            counter="5"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="mar-t-15" cols="12" md="4">
                                        <v-select
                                            label="ค่าบริการ"
                                            :items="pricex"
                                            item-text="name"
                                            item-value="id"
                                            outlined
                                            dense
                                            v-model="data_main_case.services"
                                            @change="cal()"
                                            :disabled="
                                                data_main_case.quote_status !=
                                                    'pending'
                                            "
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" class="aa-01">
                                        <span class="aa-02 ml-5">PART</span>
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-for="(row, index) in data_main_case.parts"
                                    :key="index"
                                >
                                    <v-col cols="1" class="text-right">
                                        <v-switch
                                            @change="clear_part(index)"
                                            v-model="row.part_check"
                                            :disabled="
                                                data_main_case.quote_status !=
                                                    'pending'
                                            "
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="11">
                                        <div class="mt-5">
                                            <v-chip
                                                fab
                                                class="mr-1 primary--text"
                                                v-if="row.num"
                                            >
                                                {{ row.num }}
                                            </v-chip>
                                            <v-chip color="primary">
                                                {{ row.part_name }}
                                            </v-chip>

                                            <span class="bb-03">
                                                {{ row.part_description }}
                                            </span>
                                        </div>
                                    </v-col>

                                    <v-col
                                        cols="11"
                                        sm="6"
                                        md="3"
                                        class="mar-t-30"
                                    >
                                        <v-select
                                            label="Warranty Type"
                                            :items="warranty_type"
                                            outlined
                                            dense
                                            v-model="from_warranty_type[index]"
                                            :disabled="
                                                row.part_check == undefined ||
                                                    row.part_check == false ||
                                                    data_main_case.quote_status !=
                                                        'pending'
                                            "
                                            @change="
                                                cal_warranty_type(index, row)
                                            "
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        offset-md="1"
                                        cols="11"
                                        sm="6"
                                        md="3"
                                        class="mar-t-30"
                                    >
                                        <v-text-field
                                            outlined
                                            dense
                                            v-model="row.price"
                                            label="Price"
                                            :disabled="
                                                row.part_check == undefined ||
                                                    row.part_check == false ||
                                                    data_main_case.quote_status !=
                                                        'pending'
                                            "
                                            @input="cal_part(index)"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col
                                        cols="11"
                                        sm="6"
                                        md="3"
                                        class="mar-t-30"
                                    >
                                        <v-text-field
                                            outlined
                                            dense
                                            v-model="row.discount"
                                            label="Discount (%)"
                                            :disabled="
                                                row.part_check == undefined ||
                                                    row.part_check == false ||
                                                    data_main_case.quote_status !=
                                                        'pending'
                                            "
                                            @input="cal_part(index)"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="11"
                                        sm="6"
                                        md="2"
                                        class="mar-t-30"
                                    >
                                        <span class="bb-02">
                                            {{ formatPrice(row.total_price) }}
                                        </span>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="10" class="text-right bb-01">
                                        <span class="bb-02"> รวม </span>
                                    </v-col>
                                    <v-col cols="2" class="bb-01 text-right">
                                        <span class="bb-02">
                                            {{
                                                formatPrice(
                                                    data_main_case.sub_total
                                                )
                                            }}
                                        </span>
                                    </v-col>
                                    <v-col cols="10" class="text-right bb-01">
                                        <span class="bb-02"> VAT 7% </span>
                                    </v-col>
                                    <v-col cols="2" class="bb-01 text-right">
                                        <span class="bb-02">
                                            {{
                                                formatPrice(data_main_case.vat)
                                            }}
                                        </span>
                                    </v-col>
                                    <v-col cols="10" class="text-right bb-01">
                                        <span class="bb-02"> ยอดสุทธิ </span>
                                    </v-col>
                                    <v-col cols="2" class="bb-01 text-right">
                                        <span class="bb-02">
                                            {{
                                                formatPrice(
                                                    data_main_case.grand_total
                                                )
                                            }}
                                        </span>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" md="3" offset-md="4">
                                        <v-btn
                                            color="success"
                                            block
                                            rounded
                                            @click="save_quote()"
                                        >
                                            Save Quote
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <div id="printDiv">
            <div
                v-for="n in numx"
                :key="n"
                style="background-color: rgb(255, 255, 255); padding-left: 35px"
            >
                <v-row>
                    <v-col cols="9">
                        <img
                            src="../../../assets/quote/ASUS_Letter_new_2.png"
                            width="100%"
                        />
                    </v-col>
                    <v-col
                        cols="3"
                        :style="
                            print_type == 'Receipt'
                                ? 'background-color: rgb(213, 212, 212);'
                                : ''
                        "
                        class="text-center"
                    >
                        <div v-if="print_type == 'Receipt'">
                            <br />
                            <span style="font-size: 20px">
                                {{ n == 1 ? "ต้นฉบับ" : "สำเนา" }}
                            </span>
                            <br />
                            <span style="font-size: 20px">
                                {{ n == 1 ? "Original" : "Copy" }}
                            </span>
                        </div>
                    </v-col>

                    <v-col cols="12" class="text-center mt-5">
                        <span style="font-size: 22px; font-weight: bold">
                            {{
                                print_type == "Quote"
                                    ? "ใบเสนอราคา"
                                    : "ใบเสร็จรับเงิน / ใบกำกับภาษี / ใบส่งของ"
                            }}
                        </span>
                    </v-col>
                    <v-col cols="12" class="text-center mt-2">
                        <span style="font-size: 22px; font-weight: bold">
                            {{
                                print_type == "Quote"
                                    ? "Quotation"
                                    : "Receipt / Tax Invoice / Delivery Order"
                            }}
                        </span>
                    </v-col>
                    <v-col cols="12" class="mt-3 mb-3"> </v-col>
                    <v-col cols="2" offset="7">
                        <span
                            v-if="print_type == 'Receipt'"
                            style="font-size: 17px; font-weight: bold"
                        >
                            Receipt No.
                        </span>
                    </v-col>
                    <v-col cols="3">
                        <span
                            v-if="print_type == 'Receipt'"
                            style="font-size: 17px"
                        >
                            {{ data_main_print.receipt_no }}
                        </span>
                    </v-col>
                    <v-col cols="7">
                        <span
                            style="font-size: 17px;text-decoration: underline; font-weight: bold;"
                        >
                            ข้อมูลลูกค้า / Customer's Information
                        </span>
                    </v-col>
                    <v-col cols="2">
                        <span style="font-size: 17px; font-weight: bold">
                            วันที่ / Date
                        </span>
                    </v-col>
                    <v-col cols="3">
                        <span style="font-size: 17px">
                            {{
                                print_type == "Quote"
                                    ? data_main_print.quote_date
                                    : data_main_print.receipt_date
                            }}
                        </span>
                    </v-col>

                    <v-col cols="3">
                        <span style="font-size: 17px; font-weight: bold">
                            ชื่อลูกค้า / Name
                        </span>
                    </v-col>
                    <v-col cols="4">
                        <span style="font-size: 17px">
                            {{ data_main_print.cust_name }}
                        </span>
                    </v-col>
                    <v-col cols="2">
                        <span style="font-size: 17px; font-weight: bold">
                            Case ID
                        </span>
                    </v-col>
                    <v-col cols="3">
                        <span style="font-size: 17px">
                            {{ data_main_print.case_id }}
                        </span>
                    </v-col>

                    <v-col cols="3">
                        <span style="font-size: 17px; font-weight: bold">
                            ที่อยู่ลูกค้า / Address
                        </span>
                    </v-col>
                    <v-col cols="4">
                        <span style="font-size: 17px">
                            {{ data_main_print.cust_address }}
                        </span>
                    </v-col>
                    <v-col cols="2">
                        <span style="font-size: 17px; font-weight: bold">
                            Product No.
                        </span>
                    </v-col>
                    <v-col cols="3">
                        <span style="font-size: 17px">
                            {{ data_main_print.product_no }}
                        </span>
                    </v-col>

                    <v-col cols="3">
                        <span style="font-size: 17px; font-weight: bold">
                            สาขา / Branch
                        </span>
                    </v-col>
                    <v-col cols="4">
                        <span
                            style="font-size: 17px"
                            v-if="data_main_print.cust_type == 'hq'"
                        >
                            <!-- สำนักงานใหญ่ / Head Office <br />เลขที่สาขา / Branch -->
                            00000
                        </span>
                        <span
                            style="font-size: 17px"
                            v-if="data_main_print.cust_type == 'branch'"
                        >
                            <!-- เลขที่สาขา / Branch No. : -->
                            {{ data_main_print.branch_no }}
                        </span>
                    </v-col>
                    <v-col cols="2">
                        <span style="font-size: 17px; font-weight: bold">
                            Serial No.
                        </span>
                    </v-col>
                    <v-col cols="3">
                        <span style="font-size: 17px">
                            {{ data_main_print.product_serial }}
                        </span>
                    </v-col>
                    <v-col cols="3">
                        <span style="font-size: 16px; font-weight: bold">
                            เลขประจำตัวผู้เสียภาษี / Tax ID
                        </span>
                    </v-col>
                    <v-col cols="4">
                        <span style="font-size: 17px">
                            {{ data_main_print.tax_id }}
                        </span>
                    </v-col>
                </v-row>
                <v-row class="mt-5 mb-5">
                    <v-col cols="12">
                        <table width="100%" border="1">
                            <tr>
                                <th class="text-center">Item</th>
                                <th class="text-center">Description</th>
                                <th class="text-center">Unit Price (THB)</th>
                                <th class="text-center">Qty.</th>
                                <th class="text-center">Amount (THB)</th>
                            </tr>
                            <tr v-if="data_main_print.services == 'onsite'">
                                <td class="text-center">1.</td>
                                <td>Service Charge</td>
                                <td class="text-right">1,800.00</td>
                                <td class="text-center">1</td>
                                <td class="text-right">1,800.00</td>
                            </tr>

                            <tr
                                v-for="(r, i) in data_main_print.parts"
                                :key="i"
                            >
                                <td class="text-center">{{ run_no + i }}.</td>
                                <td>
                                    {{ r.part_name + " " + r.part_description }}
                                </td>
                                <td class="text-right">
                                    {{ formatPrice(r.total_price) }}
                                </td>
                                <td class="text-center">1</td>
                                <td class="text-right">
                                    {{ formatPrice(r.total_price) }}
                                </td>
                            </tr>
                            <!-- <tr>
                                <td></td>
                                <td>
                                    - ซ่อมจอภาพ 18010-21502000 LCD TFT 21.5 FHD
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>- ค่าบริการ</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr> -->
                            <div v-if="blank_row < 7">
                                <tr v-for="index in blank_row" :key="index">
                                    <td class="text-center"></td>
                                    <td>
                                        <span style="color: #ffff">x</span>
                                    </td>
                                    <td class="text-right"></td>
                                    <td class="text-center"></td>
                                    <td class="text-right"></td>
                                </tr>
                            </div>

                            <tr>
                                <td
                                    colspan="4"
                                    class="text-right"
                                    style="font-weight: bold"
                                >
                                    Sub Total
                                </td>
                                <td class="text-right">
                                    {{ formatPrice(data_main_print.sub_total) }}
                                </td>
                            </tr>
                            <tr>
                                <td
                                    colspan="4"
                                    class="text-right"
                                    style="font-weight: bold"
                                >
                                    Vat 7%
                                </td>
                                <td class="text-right">
                                    {{ formatPrice(data_main_print.vat) }}
                                </td>
                            </tr>
                            <tr>
                                <td
                                    colspan="4"
                                    class="text-right"
                                    style="font-weight: bold"
                                >
                                    Grand Total
                                </td>
                                <td class="text-right">
                                    {{
                                        formatPrice(data_main_print.grand_total)
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td
                                    colspan="5"
                                    class="text-right"
                                    style="font-weight: bold"
                                >
                                    <span class="mr-2">{{ thb_text }}</span>
                                </td>
                            </tr>
                        </table>
                    </v-col>
                    <v-col cols="12" class="mt-4" v-if="print_type == 'Quote'">
                        <span style="font: size 20px">
                            ในกรณีที่ลูกค้าตกลงซ่อม กรุณาเช็นชื่อทางด้านซ้ายมือ
                        </span>
                    </v-col>
                </v-row>
                <v-row class="mt-5 mb-5">
                    <v-col cols="12"><br /></v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col cols="2"></v-col>
                    <v-col
                        cols="3"
                        style="border-bottom: 1px solid #000"
                    ></v-col>
                    <v-col cols="2"></v-col>
                    <v-col
                        cols="3"
                        style="border-bottom: 1px solid #000"
                    ></v-col>
                    <v-col cols="2"></v-col>
                </v-row>
                <v-row class="mt-2 mb-2">
                    <v-col cols="2"></v-col>
                    <v-col cols="3" class="text-center">
                        <span style="font: size 20px">
                            {{
                                print_type == "Quote"
                                    ? "ยินยอมการเสนอราคา / Accept"
                                    : "ผู้รับของ / Received By"
                            }}
                        </span>
                    </v-col>
                    <v-col cols="2"></v-col>
                    <v-col cols="3" class="text-center">
                        <span style="font: size 20px">
                            {{
                                print_type == "Quote"
                                    ? "ไม่ยินยอมการเสนอราคา / Reject"
                                    : "ผู้รับเงิน / Bill Collector"
                            }}
                        </span>
                    </v-col>
                    <v-col cols="2"></v-col>
                </v-row>
                <v-row class="mt-5" v-if="print_type == 'Receipt'">
                    <v-col cols="3" class="text-right">
                        <span style="font: size 20px"> วันที่ / Date. : </span>
                    </v-col>
                    <v-col
                        cols="2"
                        style="border-bottom: 1px solid #000"
                    ></v-col>
                    <v-col cols="3" class="text-right">
                        <span style="font: size 20px"> วันที่ / Date. : </span>
                    </v-col>
                    <v-col
                        cols="2"
                        style="border-bottom: 1px solid #000"
                    ></v-col>
                    <v-col cols="2"></v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col
                        cols="12"
                        v-if="print_type == 'Quote'"
                        style="font-size: 80%"
                    >
                        <span class="font-weight-bold"
                            >เงื่อนไขและข้อกำหนดในการให้บริการ / Terms and
                            Conditions of Services</span
                        ><br />
                        1. งานหมดประกันทางบริษัทฯจะมีการเรียกเก็บค่าบริการ
                        Onsite เป็นจำนวนเงิน 1,926 บาท (รวม Vat 7%)
                        ราคาดังกล่าวนี้ยังไม่รวมค่าอะไหล่<br />
                        Product out of warranty will be services charge for
                        1,926 THB (include Vat 7%) exclude parts charge.<br />
                        2. การรับประกันงานซ่อมมีระยะเวลา 90 วัน
                        นับจากวันที่ลูกค้ารับเครื่องคืน
                        หากเครื่องเกิดขัดข้องด้วยอาการเดิมอีก
                        ทางบริษัทฯยินดีบริการซ่อมให้โดยไม่มีค่าใช้จ่าย
                        ยกเว้นค่าอะไหล่ที่ไม่ใช่ตัวเดิม
                        และมีความจำเป็นต้องเปลี่ยนเพิ่ม<br />
                        If same issues occurs, Free of charge services for 90
                        days after customer pick up product. exclude parts
                        charge. (if any)<br />
                        3. ทางบริษัทฯขอสงวนสิทธิในการเรียกเก็บค่าบริการเต็มจำนวน
                        ในกรณีที่ลูกค้ายกเลิกการซ่อม ทั้งขณะกำลังซ่อม
                        หรือเริ่มดำเนินการซ่อมแล้ว
                        หรือภายหลังการซ่อมเสร็จเรียบร้อยแล้ว<br />
                        During the services any cancellation, we have charge
                        100% of services charge.<br />
                        4.
                        ทางบริษัทฯจะทำการซ่อมหลังจากที่ลูกค้าได้อนุมัติการซ่อม
                        ตามใบเสนอราคาที่ลูกค้าเซ็นเอกสารเป็นลายลักษณ์อักษรแล้ว
                        <br />
                        Services will be start after customer accept by sign on
                        quotation.<br />
                        5. ราคาในใบเสนอราคานี้จะอยู่ภายใน 14
                        วันนับจากวันที่เสนอราคาเท่านั้น หากเกินระยะเวลาที่กำหนด
                        จะถือว่าลูกค้ายกเลิกใบเสนอราคา <br />
                        This quotation will be expired in 14 days since quote
                        date. After that, this quotation will be cancelled.<br />
                        6.
                        กรณีลูกค้าขอทำเรื่องเบิกเงินก่อนทางบริษัทขออนุญาตยกเลิกการปฏิบัติงาน
                        จนกว่าลูกค้าพร้อมจะชำระเงินสด<br />
                        In case of customer have wait for withdrawal process,
                        this operation have to be cancelled until the process
                        completed.<br />
                        7. ศูนย์บริการเปิดทำการจันทร์ - ศุกร์ เวลา 8.30 - 17.30
                        น. ยกเว้นวันหยุดราชการ <br />
                        Customer services available on Monday - Friday (8.30 -
                        17.30) exclude public holidays.<br />
                        สามารถโทรติดต่อได้ที่เบอร์ กรุงเทพฯ/Bangkok :
                        090-197-3294 , ต่างจังหวัด/Upcounty: 090-197-3295
                    </v-col>
                    <v-col cols="12" v-else style="font-size: 80%">
                        <span class="font-weight-bold"
                            >เงื่อนไขและข้อกำหนดในการให้บริการ / Terms and
                            Conditions of Services</span
                        ><br />
                        1. การรับประกันงานซ่อมมีระยะเวลา 90 วัน
                        นับจากวันที่ลูกค้ารับเครื่องคืน
                        หากเครื่องเกิดขัดข้องด้วยอาการเดิมอีก
                        ทางบริษัทฯยินดีบริการซ่อมให้โดยไม่มีค่าใช้จ่าย
                        ยกเว้นค่าอะไหล่ที่ไม่ใช่ตัวเดิม
                        และมีความจำเป็นต้องเปลี่ยนเพิ่ม<br />
                        If same issues occurs, Free of charge services for 90
                        days after customer pick up product. exclude parts
                        charge. (if any)<br />
                        2. ทางบริษัทฯขอสงวนสิทธิในการเรียกเก็บค่าบริการเต็มจำนวน
                        ในกรณีที่ลูกค้ายกเลิกการซ่อม ทั้งขณะกำลังซ่อม
                        หรือเริ่มดำเนินการซ่อมแล้ว
                        หรือภายหลังการซ่อมเสร็จเรียบร้อยแล้ว<br />
                        During the services any cancellation, we have charge
                        100% of services charge.<br />
                        3. กรุณาตรวจเช็คอุปกรณ์ต่างๆให้เรียบร้อย
                        ก่อนนำเครื่องออกจากบริษัทฯ มิฉะนั้นบริษัทฯ
                        จะไม่รับผิดชอบใดๆทั้งสิ้น<br />
                        Please check product before receive, Otherwise company
                        will not responsible for any issues. <br />
                        4. ศูนย์บริการเปิดทำการจันทร์ - ศุกร์ เวลา 8.30 - 17.30
                        น. ยกเว้นวันหยุดราชการ <br />
                        Customer services available on Monday - Friday (8.30 -
                        17.30) exclude public holidays.<br />
                        สามารถโทรติดต่อได้ที่เบอร์ กรุงเทพฯ/Bangkok :
                        090-197-3294 , ต่างจังหวัด/Upcounty: 090-197-3295
                    </v-col>
                </v-row>

                <div
                    style="page-break-after: always"
                    v-if="print_type == 'Receipt'"
                ></div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import { normalize } from "path"
import THBText from "thai-baht-text"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    props: ["maincase_id"],
    watch: {
        maincase_id: function(val) {
            this.get_data()
        },
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        if (this.maincase_id != undefined) {
            this.get_data()
        }
    },
    methods: {
        async get_data() {
            this.dialog_loading = true
            await axios
                .get(url + "quote/quote-detail/" + this.maincase_id, this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_main = response.data
                })
                .catch((error) => {
                    this.dialog_loading = false
                    console.log(error, "---error")
                })
        },
        add_close() {
            this.status_save = "add"
            this.dialog_detail = true
            this.get_data_case()
        },
        close_dialog() {
            this.status_save = ""
            this.dialog_detail = false
        },
        async get_data_case() {
            this.dialog_loading = true
            await axios
                .get(url + "quote/case-detail/" + this.maincase_id, this.tk)
                .then((response) => {
                    // console.log(response.data.parts, "-get_data_case")
                    this.num_part = 0
                    this.data_main_case = response.data
                    this.data_main_case.quote_status = "pending"
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        clear_type() {
            if (this.data_main_case.type == "foreigner") {
                this.data_main_case.tax_id = ""
            }
        },
        clear_part(idx) {
            this.from_warranty_type[idx] = null
            if (this.data_main_case.parts[idx].part_check == true) {
                this.data_main_case.parts[idx].num = this.num_part += 1
            }

            this.data_main_case.parts[idx].discount = 0
            if (this.data_main_case.parts[idx].part_check == false) {
                this.data_main_case.parts[idx].price = 0
                this.data_main_case.parts[idx].total_price = 0
                this.data_main_case.parts[idx].num = 0
                this.num_part--
                this.cal()
            }
        },
        cal_warranty_type(idx, data) {
            // console.log(this.from_warranty_type[idx])
            // console.log(data)
            if (this.from_warranty_type[idx] == "OOW") {
                this.data_main_case.parts[idx].price = data.oow_enduser
                this.data_main_case.parts[idx].warranty_type = "OOW"
                this.data_main_case.parts[idx].cost = data.oow_dealer
                this.data_main_case.parts[idx].cost = data.oow_dealer
            } else if (this.from_warranty_type[idx] == "ADP") {
                this.data_main_case.parts[idx].price = data.perfect_enduser
                this.data_main_case.parts[idx].warranty_type = "ADP"
                this.data_main_case.parts[idx].cost = data.perfect_dealer
            } else if (this.from_warranty_type[idx] == "CID") {
                this.data_main_case.parts[idx].price = data.oow_enduser
                this.data_main_case.parts[idx].warranty_type = "CID"
                this.data_main_case.parts[idx].cost = data.oow_dealer
            }

            this.cal_part(idx)
        },
        cal_part(idx) {
            let total
            let discount
            total = this.data_main_case.parts[idx].price
            discount = (total * this.data_main_case.parts[idx].discount) / 100
            this.data_main_case.parts[idx].total_price = total - discount
            this.cal()
        },
        cal() {
            let total = 0
            if (this.data_main_case.services == "onsite") {
                total += 1800
            }
            this.data_main_case.parts.map((r) => {
                if (this.status_save == "edit") {
                    if (r.part_check == "true" || r.part_check == true) {
                        r.part_check = true
                    } else {
                        r.part_check = false
                    }
                }
                if (r.part_check == true) {
                    total += parseFloat(r.total_price)
                }
            })

            this.data_main_case.sub_total = total
            this.data_main_case.vat = (total * 7) / 100
            if (this.data_main_case.manual == "Y") {
                this.data_main_case.vat = parseFloat(
                    this.data_main_case.vat
                        .toString()
                        .match(/^-?\d+(?:\.\d{0,2})?/)[0]
                )
            }
            let a = this.data_main_case.sub_total + this.data_main_case.vat
            this.data_main_case.grand_total = a
        },
        formatPrice(value) {
            value = value == undefined ? 0 : value
            let val = (value / 1).toFixed(2).replace(",", ".")
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        async save_quote() {
            this.dialog_loading = true
            let urlx
            this.status_save == "add"
                ? (urlx = "quote/save")
                : (urlx = "quote/edit-save")
            await axios
                .post(url + urlx, this.data_main_case, this.tk)
                .then((response) => {
                    this.dialog_detail = false
                    this.dialog_loading = false
                    this.data_main = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_print_quote(idx, typex) {
            this.dialog_loading = true
            this.print_type = ""
            await axios
                .get(url + "quote/print-detail/" + idx + "/" + typex, this.tk)
                .then((response) => {
                    // console.log(response, "-get_print_quote")
                    this.data_main_print = response.data

                    let x = parseFloat(
                        this.data_main_print.grand_total
                    ).toFixed(2)

                    this.thb_text = THBText(x)
                    this.print_type = typex

                    this.run_no =
                        this.data_main_print.services == "onsite" ? 2 : 1
                    if (this.data_main_print.parts.length <= 15) {
                        this.blank_row =
                            16 -
                            (this.run_no + this.data_main_print.parts.length)
                    }
                    this.print_type == "Quote"
                        ? (this.numx = 1)
                        : (this.numx = 3)
                    this.partsx = response.data
                    console.log(this.data_main_print.parts)
                    console.log(this.blank_row, "-blank_row")

                    setTimeout(() => {
                        // console.log(this.data_main_print)
                        this.dialog_loading = false
                        // this.print()
                        this.$htmlToPaper("printDiv")
                    }, 1500)
                    // if (typex == "Receipt") {
                    //     this.get_data()
                    // }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        close_dialog_update() {
            this.form_update = {
                quote_id: 0,
                quote_status: null,
            }
            this.dialog_update = false
        },
        open_update_quote(idx) {
            this.form_update.quote_id = idx
            this.dialog_update = true
        },
        async update_quote() {
            this.dialog_loading = true
            await axios
                .post(url + "quote/uudate-status/", this.form_update, this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.get_data()
                    this.close_dialog_update()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        // print() {
        //     this.$htmlToPaper("printDiv")
        // },
        async open_edit_quote(idx) {
            this.dialog_loading = true
            await axios
                .get(url + "quote/edit/" + idx, this.tk)
                .then((response) => {
                    // console.log(response, "-open_edit_quote")
                    this.dialog_loading = false
                    this.data_main_case = response.data
                    setTimeout(() => {
                        this.status_save = "edit"
                        this.dialog_detail = true
                        this.cal()
                    }, 1500)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async gen_receipt(idx) {
            this.dialog_loading = true
            await axios
                .get(url + "quote/generate-receipt/" + idx, this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.get_data()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
    },
    data() {
        return {
            num_part: 0,
            emp_id: localStorage.emp_img,
            partsx: [],
            numx: 1,
            thb_text: "",
            tk: null,
            data_main: [],
            data_main_print: {
                parts: [],
            },
            print_type: "",
            data_main_case: [],
            dialog_loading: false,
            id_main_case: null,
            dialog_detail: false,
            modal: false,
            date: false,
            typex: [
                {
                    id: "normal",
                    name: "บุคคลธรรมดา",
                },
                {
                    id: "foreigner",
                    name: "ชาวต่างชาติ",
                },
                {
                    id: "hq",
                    name: "สำนักงานใหญ่",
                },
                {
                    id: "branch",
                    name: "สาขา",
                },
            ],
            pricex: [
                {
                    id: "no",
                    name: "ไม่มี",
                },
                {
                    id: "onsite",
                    name: "Onsite - 1,800 บาท",
                },
            ],
            status_update: [
                {
                    id: "approved",
                    name: "ตกลงซ่อม",
                },
                {
                    id: "rejected",
                    name: "ไม่ตกลงซ่อม",
                },
                // {
                //     id: "cancelled",
                //     name: "ยกเลิกการซ่อม",
                // },
            ],
            dialog_update: false,
            form_update: {
                quote_id: 0,
                quote_status: null,
            },
            run_no: 0,
            blank_row: 0,
            status_save: "",
            team_name: localStorage.team_name,
            rules1: [(v) => v.length <= 13 || "Max 13"],
            rules2: [(v) => v.length <= 5 || "Max 5"],
            warranty_type: ["OOW", "ADP", "CID"],
            from_warranty_type: [],
        }
    },
}
</script>
<style scoped>
.aa-01 {
    background-color: rgb(92, 157, 253) !important;
}
.aa-02 {
    margin-right: 40px;
    font-weight: bold !important;
    font-size: 20px;
    color: #ffff;
}
.bb-01 {
    background-color: rgb(209, 221, 223) !important;
}
.bb-02 {
    margin-right: 40px;
    font-weight: bold !important;
    font-size: 20px;
    color: rgb(30, 85, 122);
}
.bb-03 {
    /* margin-right: 40px; */
    font-weight: bold !important;
    font-size: 17px;
    color: rgb(30, 85, 122);
}
#printDiv {
    display: none;
}
</style>
